import axios from 'axios';

export default {
    namespaced: true,

    state: {
        settings: {}
    },

    mutations: {
        setSetting(state, setting) {
            state.settings[setting.settingName] = setting.settingArray;
        }
    },

    actions: {
        getAllSettings({commit}) {
            return new Promise(resolve => {
                axios.get('/api/settings/frontend/')
                    .then(response => {
                        response.data.settings.forEach(setting => {
                            commit('setSetting', setting);
                        });
                        resolve();
                    })
                    .catch(() => {
                        resolve();
                    });
            });
        },
    }
};
